import React from 'react';
import s from '../../pages/PDV.module.css';

export default function ModalDiagnosticoNfce({ modalDiagnostico, setModalDiagnostico, dadosDiagnostico }) {
  if (!modalDiagnostico || !dadosDiagnostico) return null;
  return (
        <div className={s.modalOverlay} onClick={() => setModalDiagnostico(false)}>
          <div className={s.modalDiagnostico} onClick={e => e.stopPropagation()}>
            <div className={s.modalTitleBar}>
              <span>🔍 Diagnóstico NFC-e — {dadosDiagnostico.tipo?.toUpperCase()}</span>
              <button className={s.modalClose} onClick={() => setModalDiagnostico(false)}>✕</button>
            </div>
            <div className={s.diagBody}>
              <section className={s.diagSecao}>
                <div className={s.diagTituloSecao}>Mensagem de erro</div>
                <pre className={s.diagPre}>{dadosDiagnostico.motivo || dadosDiagnostico.erro || '—'}</pre>
              </section>

              {dadosDiagnostico.sefaz_status && (
                <section className={s.diagSecao}>
                  <div className={s.diagTituloSecao}>HTTP Status SEFAZ</div>
                  <pre className={s.diagPre}>{dadosDiagnostico.sefaz_status}</pre>
                </section>
              )}

              {dadosDiagnostico.sefaz_resposta && (
                <section className={s.diagSecao}>
                  <div className={s.diagTituloSecao}>Resposta da SEFAZ</div>
                  <pre className={s.diagPre}>{dadosDiagnostico.sefaz_resposta}</pre>
                </section>
              )}

              {dadosDiagnostico.xml_gerado && (
                <section className={s.diagSecao}>
                  <div className={s.diagTituloSecao}>XML Gerado (antes da assinatura)</div>
                  <pre className={s.diagPre}>{dadosDiagnostico.xml_gerado}</pre>
                </section>
              )}

              {dadosDiagnostico.xml_assinado && (
                <section className={s.diagSecao}>
                  <div className={s.diagTituloSecao}>XML Assinado (enviado à SEFAZ)</div>
                  <pre className={s.diagPre}>{dadosDiagnostico.xml_assinado}</pre>
                </section>
              )}
            </div>
            <div className={s.modalFooter} style={{ justifyContent: 'flex-end' }}>
              <button className={s.btnCancelarModal} onClick={() => setModalDiagnostico(false)}>Fechar</button>
            </div>
          </div>
        </div>
  );
}
